module.exports = __webpack_public_path__ + "static/media/iconInfo.25848ceb.svg";